import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../lib/api";
import { SortableList, inputCls } from "../../components/admin/fields";
import { formatRunDates } from "../../utils/dates";

export default function ExhibitionsListPage() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [status, setStatus] = useState("");
  const navigate = useNavigate();

  const load = () => {
    const params = new URLSearchParams();
    if (q) params.set("q", q);
    if (status) params.set("status", status);
    api.get(`/admin/exhibitions?${params}`).then((res) => setItems(res.data || [])).catch(() => {});
  };

  useEffect(load, [q, status]);

  const createNew = async () => {
    const { data } = await api.post("/admin/exhibitions", { title: "Untitled exhibition", status: "draft" });
    navigate(`/admin/exhibitions/${data.id}`);
  };

  const persistOrder = async (ordered) => {
    await api.post("/admin/exhibitions/reorder", { ids: ordered.map((e) => e.id) });
  };

  return (
    <div data-testid="admin-exhibitions">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <h1 className="h-condensed text-4xl">Exhibitions</h1>
        <button type="button" onClick={createNew} data-testid="new-exhibition-button" className="link-arrow text-xs">
          New exhibition
        </button>
      </div>

      <div className="mt-8 flex flex-wrap gap-4">
        <input
          type="search"
          placeholder="Search titles…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          className={`${inputCls} max-w-xs`}
          data-testid="exhibitions-search"
        />
        <select value={status} onChange={(e) => setStatus(e.target.value)} className={`${inputCls} max-w-[180px]`} data-testid="exhibitions-status-filter">
          <option value="">All statuses</option>
          <option value="published">Published</option>
          <option value="draft">Draft</option>
        </select>
        <p className="self-center text-xs font-light opacity-60">Drag rows to reorder.</p>
      </div>

      <div className="mt-6 border-t border-charcoal">
        <SortableList
          items={items}
          onChange={setItems}
          onPersist={() => persistOrder(items)}
          keyFn={(e) => e.id}
          testid="exhibitions-list"
          renderItem={(ex) => (
            <button
              type="button"
              onClick={() => navigate(`/admin/exhibitions/${ex.id}`)}
              data-testid={`exhibition-row-${ex.slug}`}
              className="flex w-full items-center gap-5 border-b border-charcoal py-4 text-left transition-colors duration-300 hover:bg-stone-40"
            >
              {ex.card_image && <img src={ex.card_image} alt="" className="h-14 w-11 object-cover" />}
              <span className="flex-1">
                <span className="h-condensed block text-xl">{ex.title}</span>
                <span className="mt-0.5 block text-xs font-light opacity-60">
                  {ex.gallery} · {ex.city} · {formatRunDates(ex.start_date, ex.end_date)}
                </span>
              </span>
              {ex.show_in_recent && <span className="eyebrow text-[0.6rem] opacity-70">In bar</span>}
              <span className={`eyebrow text-[0.6rem] ${ex.status === "published" ? "" : "opacity-40"}`}>
                {ex.status === "published" ? "Published" : "Draft"}
              </span>
            </button>
          )}
        />
        {items.length === 0 && <p className="py-8 text-sm font-light opacity-60">No exhibitions found.</p>}
      </div>
    </div>
  );
}
